export default "__VITE_ASSET__CVSajuaU__"